import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { hot } from 'react-hot-loader/root';
import { compose } from 'redux';

import { DevelopersCompanyContext } from 'common/containers/DevelopersCompanyContainer';
import MultiLanguageCodeBlock from 'common/developers/docs/widget/MultiLanguageCodeBlock';
import AngularAdvancedSnippet from 'common/developers/docs/widget/snippets/AngularAdvancedSnippet';
import ReactAdvancedSnippet from 'common/developers/docs/widget/snippets/ReactAdvancedSnippet';
import VueAdvancedSnippet from 'common/developers/docs/widget/snippets/VueAdvancedSnippet';
import WebAdvancedSnippet from 'common/developers/docs/widget/snippets/WebAdvancedSnippet';
import WidgetDocsWarning from 'common/developers/docs/widget/WidgetDocsWarning';
import WidgetDocsWebHelmet from 'common/helmets/WidgetDocsWebHelmet';
import BoardPicker from 'common/subdomain/admin/BoardPicker';
import withContexts from 'common/util/withContexts';

import 'css/components/developers/docs/widget/_WidgetDocsWeb.scss';

class WidgetDocsWeb extends Component {
  static propTypes = {
    company: PropTypes.shape({
      boards: PropTypes.array,
    }),
  };

  state = {
    board: null,
  };

  onBoardSelected = (board) => {
    this.setState({
      board,
    });
  };

  render() {
    const { company } = this.props;
    const boards = company ? company.boards : null;
    const { board } = this.state;

    return (
      <div className="widgetDocsWeb">
        <WidgetDocsWebHelmet />
        <WidgetDocsWarning />
        <div className="title">Advanced Widget Features</div>
        <ul className="numberedList">
          <li>
            <div className="subheading">Web Widget "Ready" Callback</div>
            <div className="contents">
              In some cases, you may want to be informed when the web widget has finished loading.
              This can be helpful for showing and hiding loading states, or other
              conditional&nbsp;views.
            </div>
            <div className="contents">
              The widget configuration accepts an optional{' '}
              <span className="code">onLoadCallback</span> parameter, which will run a specified
              function when the web widget has finished&nbsp;loading.
            </div>
            {boards ? (
              <BoardPicker
                boards={boards}
                placeholder="Fill in board token for:"
                onBoardSelected={this.onBoardSelected}
              />
            ) : (
              <div className="contents">
                <span className="bold">To find your board token</span>, log in above and select your
                board from the&nbsp;dropdown.
              </div>
            )}
            <div className="contents">
              <MultiLanguageCodeBlock
                blocks={[
                  {
                    code: board
                      ? WebAdvancedSnippet.replace('YOUR_BOARD_TOKEN', board.token)
                      : WebAdvancedSnippet,
                    language: 'html',
                    name: 'HTML',
                  },
                  {
                    code: board
                      ? ReactAdvancedSnippet.replace('YOUR_BOARD_TOKEN', board.token)
                      : ReactAdvancedSnippet,
                    language: 'js',
                    name: 'React',
                  },
                  {
                    code: board
                      ? AngularAdvancedSnippet.replace('YOUR_BOARD_TOKEN', board.token)
                      : AngularAdvancedSnippet,
                    language: 'js',
                    name: 'Angular',
                  },
                  {
                    code: board
                      ? VueAdvancedSnippet.replace('YOUR_BOARD_TOKEN', board.token)
                      : VueAdvancedSnippet,
                    language: 'html',
                    name: 'Vue.js',
                  },
                ]}
              />
            </div>
          </li>
          <li>
            <div className="subheading">Questions</div>
            <div className="contents">
              If you have any questions or issues, email us at{' '}
              <a href="mailto:support@canny.io">support@canny.io</a> and we'll get back to
              you&nbsp;ASAP.
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default compose(withContexts({ company: DevelopersCompanyContext }), hot)(WidgetDocsWeb);
